import {ServiceCategory} from "@/ui/service-block/ServiceBlock";
export const GENERAL_SERVICE_TERM_1 = "Residential";
export const GENERAL_SERVICE_TERM_2 = "Solar";
export const GENERAL_SERVICE_TERM_3 = "Services";

export const serviceBlockData : ServiceCategory[] = [
    {
        title: "Residential",
        services: [
            "Indoor & Outdoor Lighting Installation Sydney",
            "Switchboard Upgrades & Safety Switches Sydney",
            "Ceiling Fan & Exhaust Fan Installation Sydney",
            "Home Electrical Safety Inspections Sydney",
            "Power Point & Appliance Installations Sydney",
            "Smart Home Wiring & Automation Sydney",
            "Emergency Electrical Repairs Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-1.jpg",
    },
    {
        title: "Solar",
        services: [
            "Residential Solar Panel Installation Sydney",
            "Solar Battery Storage Installation Sydney",
            "Solar Inverter Replacement & Servicing Sydney",
            "Solar Repairs & Maintenance Sydney",
            "Energy-Efficient Home Solar Packages Sydney",
            "Rooftop Solar Panel Upgrades Sydney",
            "Free Residential Solar Quotes Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-2.jpg",
    },
    {
        title: "Commercial",
        services: [
            "Commercial Solar Power Installation Sydney",
            "Office & Retail Electrical Fit-Outs Sydney",
            "Data Cabling & Network Wiring Sydney",
            "Industrial Switchboard Upgrades Sydney",
            "LED Lighting Solutions for Businesses Sydney",
            "EV Charger Installation for Businesses Sydney",
            "Commercial Electrical Maintenance Contracts Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-3.jpg",
    }
]
